import { css } from "@emotion/react";

export const HEADER_HEIGHT = "72px";
export const HEADER_HEIGHT_MOBILE = "64px";

export const navItem = css`
    color: black;
    min-width: 2.5rem;
`;

export const headerWrapper = css`
    height: ${HEADER_HEIGHT_MOBILE};

    @media (min-width: 992px) {
        height: ${HEADER_HEIGHT};
    }
`;
